import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { upsellBannerContentStyles } from './styles/upsell-banner-content.styles';
import type { UpsellBannerContentPropsInterface } from './types/upsell-banner-content.types';

/**
 * @since 10.0.0
 */
export const UpsellBannerContent = forwardRef<HTMLDivElement, UpsellBannerContentPropsInterface>(
  (props: UpsellBannerContentPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const styles = css(upsellBannerContentStyles, cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="UpsellBanner.Content"
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

UpsellBannerContent.displayName = 'UpsellBanner.Content';
